<template>
    <div>
        <div class="clearfix">
            <button class="btn btn-primary m-2 float-right" data-toggle="modal" data-target="#description_modal">
                {{ $t('deposit.add_account') }}
            </button>
            <div id="description_modal" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div id="data_sheet" class="modal-body mb-4">
                            <div class="modal-header">
                                <h4 class="modal-title">
                                    {{ $t('deposit.add_account') }}
                                </h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="m-4">
                                <form @submit.prevent="addNewAccount" method="post" id="add_new_account">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="12">
                                                <kt-form-group>
                                                    <kt-form-label for="title">
                                                        {{ $t('label.title') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        ref="title"
                                                        dir="rtl"
                                                        name="title"
                                                        id="title"
                                                        v-model="new_account.title"
                                                    />
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col xs="12" sm="12" md="12">
                                                <kt-form-group>
                                                    <kt-form-label for="sheba">
                                                        {{ $t('label.sheba_number') }}
                                                    </kt-form-label>
                                                    <img v-show="src" style="position:absolute;left: 5px;bottom: 66px"
                                                         width="40px" height="40px" :src="src">
                                                    <kt-form-control
                                                        style="direction: ltr"
                                                        id="sheba"
                                                        name="sheba"
                                                        :onkeyup="getBank()"
                                                        v-model="new_account.sheba"
                                                        class="form-control transfers_destination_number"
                                                    ></kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col xs="12" sm="12" md="12">
                                                <kt-form-group>
                                                    <kt-form-label for="account_number">
                                                        {{ $t('label.account_number') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        ref="account_number"
                                                        dir="ltr"
                                                        name="account_number"
                                                        id="account_number"
                                                        v-model="new_account.account_number"
                                                    />
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <kt-row>
                                            <kt-col xs="12" sm="6" md="6">
                                                <button
                                                    class="btn btn-success btn-wide float-left"
                                                    size="md"
                                                    type="submit"
                                                    id="add_new_account_btn"
                                                >
                                                    {{ $t('btn.register') }}
                                                </button>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <accounts-filter :action="filterAction"></accounts-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from './datatable/columns'
import {ApiUrl, depositPfService, depositStarshopService, StarShopApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './actions-column'
import accountsFilter from './filter'
import MainContent from "../../../../components/main-content";
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";

export default {

    components: {
        MainContent,
        'accounts-filter': accountsFilter,
    },
    data() {
        return {
            query: {},
            currentTab: 1,
            new_account: {},
            src: null,
            bank_name: null,
            depositPfService,
            depositStarshopService
        }
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        datatableProps() {
            return {
                id: "deposit_accounts_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.gatewaySource === 'pf' ? ApiUrl.path('open-banking/deposit/admin/accounts'):
                                StarShopApiUrl.path('open-banking/deposit/admin/accounts'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.query.sheba) {
                let sheba = this.query.sheba
                sheba = sheba.split('-').join('')
                sheba = sheba.split(' ').join('')
                sheba = sheba.split('_').join('')
                if (sheba.length != 26)
                    sheba = ''
                this.query.sheba = sheba
            }
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        gotoTab(index) {
            this.currentTab = index;
        },
        addNewAccount(e) {
            let btn = $('#add_new_account_btn')
            let form = $('#add_new_account')

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                    sheba: {
                        required: true,
                    },
                    account_number: {
                        required: true
                    },
                }
            });

            if (!form.valid()) {
                return
            }

            let sheba = this.new_account.sheba
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')
            this.new_account.sheba = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            KTApp.progress(btn)
            this.new_account.bank_name = this.BankNameBySheba(sheba)
            // console.log(this.apiService)
            this.apiService.addAccount(this.new_account)
                .then(response => {
                    KTApp.unprogress(btn)
                    $('#description_modal').modal('hide')
                    this.query = {}
                    this.$refs.datatable.reload();
                    this.new_account = {};
                    this.toastr.success(response.data.message)
                }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                KTApp.unprogress(btn)
                this.toastr.error(response.data.message)
            }).finally(() => {
                // KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        },
        getBank() {
            this.bank_name = this.BankNameBySheba(this.new_account.sheba)

            if (!this.bank_name) {
                this.src = null
                return
            }
            this.src = this.BankLogo(this.bank_name);
        }
    }
}
</script>

<style>

</style>